var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-view-area',[_c('iv-quick-list',{attrs:{"quick":_vm.quick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }